import ReactPlayer from "react-player/youtube";

import FormattedText from "../../components/FormattedText";
import BlogListItem from "../../components/blogs/BlogListItem";
import { UserFormatableTextDisplay } from "../../components/form-fields/UserFormatableText";
import PageLoadingMessage from "../../components/PageLoadingMessage";
import { SimpleProjectListItem } from "../../components/projects/ProjectListItem";
import { useProjectData } from "../../components/ProjectDataContext";
import useSWR from "swr";

const OrganizationDetailsAboutTab = ({ username }) => {
  const { data } = useSWR(`/api/organizations/?username=${username}`);

  const organization = data?.results[0];
  if (!organization) {
    return null;
  }

  return (
    <div className="container">
      {organization.organization_profile.intro && (
        <h2 className="subtitle block is-italic">
          {organization.organization_profile.intro}
        </h2>
      )}

      <h2 className="subtitle">{`About ${organization.organization_profile.name}`}</h2>
      <UserFormatableTextDisplay
        value={organization.organization_profile.biography || "No biography..."}
      />

      {organization.organization_profile.video_link && (
        <div
          className="video-container mt-6"
          style={{ position: "relative", paddingTop: "56.25%", maxWidth: 640 }}
        >
          <ReactPlayer
            style={{
              position: "absolute",
              top: 0,
              left: 0,
            }}
            width="100%"
            height="100%"
            url={organization.organization_profile.video_link}
          />
        </div>
      )}
    </div>
  );
};

const OrganizationDetailsBlogTab = ({ username }) => {
  const { data } = useSWR(`/api/organizations/?username=${username}`);
  const { data: organizationBlogs } = useSWR(
    () => `/api/blog-posts/?created_by_user_id=${data.results[0].id}`
  );

  const organization = data?.results[0];
  if (!organization) {
    return null;
  }

  return (
    <div className="container">
      <h2 className="subtitle">{`${organization.organization_profile.name}'s Blog Posts`}</h2>

      <div>
        {organizationBlogs?.results.length === 0 && "No blogs posts yet!"}
        {organizationBlogs?.results &&
          organizationBlogs.results.map((blog) => (
            <BlogListItem key={blog.id} blog={blog} />
          ))}
        {!!organizationBlogs || "Loading blog posts..."}
      </div>
    </div>
  );
};

const ListProjects = ({ organizationUserId }) => {
  const { data: projects, error } = useSWR(
    `/api/projects/?created_by_user_id=${organizationUserId}`
  );

  const isLoading = !projects && !error;

  return (
    <div className="organization-projects mt-6">
      <h2 className="subtitle">Our Projects</h2>
      <div className="projects-list">
        {isLoading && <PageLoadingMessage message="Loading projects..." />}
        {!isLoading && (
          <div>
            {projects?.results.map((p) => (
              <SimpleProjectListItem key={p.id} project={p} trimTill={300} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const OrganizationDetailsGetInvolvedTab = ({ username }) => {
  const { projectNeeds: validSeekingOptions } = useProjectData();

  const { data } = useSWR(`/api/organizations/?username=${username}`);

  const organization = data?.results[0];
  if (!organization) {
    return null;
  }

  return (
    <div className="container">
      <h2 className="subtitle">{`Get Involved with ${organization.organization_profile.name}`}</h2>
      {organization.organization_profile.seeking && (
        <div className="block" style={{ display: "inline-flex" }}>
          {"We are looking for: "}
          <span className="pl-1 tags">
            {validSeekingOptions
              .filter(({ value }) =>
                organization.organization_profile.seeking.includes(value)
              )
              .map((projectNeed) => (
                <span className="tag is-light" key={projectNeed.value}>
                  {projectNeed.label}
                </span>
              ))}
          </span>
        </div>
      )}
      <div className="content">
        <FormattedText>
          {organization.organization_profile.get_involved_page_message ||
            "Reach out and see where we can use your help!"}
        </FormattedText>
      </div>
      {organization.organization_profile.show_projects_on_get_involved_page && (
        <ListProjects organizationUserId={organization.id} />
      )}
    </div>
  );
};

export {
  OrganizationDetailsBlogTab,
  OrganizationDetailsGetInvolvedTab,
  OrganizationDetailsAboutTab,
};
